import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// NOTES:
// - put more specific redirects first
// - use absolute paths to ensure no weird relative path behavior
var REDIRECTS = [{
  from: '/radio',
  to: '/try/radio',
  status: 301
}, // Deprecated live routes
{
  from: '/purchase/live(/**)(/**)',
  to: '/',
  status: 301
}, {
  from: '/signup/live(/**)(/**)',
  to: '/',
  status: 301
}, // Deprecated angular routes
{
  from: '/classes',
  to: '/search',
  status: 301
}, {
  from: '/classes/refer',
  to: '/search',
  status: 301
}, {
  from: '/classes/welcome',
  to: '/search',
  status: 301
}, {
  from: '/studios',
  to: '/search',
  status: 301
}];
export var asRedirectRoute = function asRedirectRoute(_ref) {
  var from = _ref.from,
      to = _ref.to,
      stripQuery = _ref.stripQuery,
      status = _ref.status;
  return {
    path: from,
    onEnter: function onEnter(_ref2, replace) {
      var location = _ref2.location;
      return replace(_objectSpread({
        pathname: to
      }, !stripQuery && location.query && {
        query: location.query
      }, status && {
        state: {
          status: status
        }
      }));
    }
  };
};
export default REDIRECTS.map(asRedirectRoute);